import { render, staticRenderFns } from "./move.vue?vue&type=template&id=3ebb7187&"
import script from "./move.vue?vue&type=script&lang=js&"
export * from "./move.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports